(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cubey-bundleup-offer-guard"] && !Shopify.designMode) return;
  try {
    class CubeyBundleUpOfferGuard extends HTMLElement {
    #observer;

    connectedCallback() {
      const root = this.closest('.product-details');
      if (!root || !this.dataset.productId) return;

      this.#removeOffer(root);
      this.#observer = new MutationObserver(() => this.#removeOffer(root));
      this.#observer.observe(root, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }

    #removeOffer(root) {
      const offer = root.querySelector('#bundle-up');
      if (offer) offer.remove();

      // The BundleUp app sets `style="display: none"` directly on the theme's
      // native product form whenever it activates, even though its own offer
      // is removed above. Clear that inline style so the native buy buttons
      // (Add to cart, quantity selector, accelerated checkout) show again.
      const form = root.querySelector('form.shopify-product-form');
      if (form && form.style.display === 'none') {
        form.style.removeProperty('display');
      }
    }
  }

  if (!customElements.get('cubey-bundleup-offer-guard')) {
    customElements.define('cubey-bundleup-offer-guard', CubeyBundleUpOfferGuard);
  }
  } catch(e) { console.error(e); }
})();

})();
